import React from 'react';
import {FormGroupContext} from './context';

/**
 * The primary way to use the FormGroupContext values.
 */
export const useFormGroupState = () => React.useContext(FormGroupContext);

/**
 * Registering a control with the FormGroup to ensure it gets the correct
 * for the form elmeent.
 */
export const useFormGroupId = (preferredId?: string) => {
  const {registerControlId, baseId} = useFormGroupState();

  const reactId = React.useId(); // SSR-safe, globally unique
  const controlId = React.useMemo(() => reactId.replace(/:/g, ''), [reactId]); // Clean up for HTML IDs

  React.useEffect(
    () => registerControlId(controlId, preferredId),
    [registerControlId, controlId, preferredId]
  );

  const automatedId = baseId ? `${baseId}-${controlId}` : controlId;
  let id = preferredId || automatedId;

  /**
   * When ids are generated outside of FormGroup, it will just be a number.
   * We need to prefix it with `form-group`, so that `0` becomes
   * `form-group-0`.
   */
  if (!isNaN(Number(id))) {
    id = `form-group-${id}`;
  }

  return id;
};
